<template>
  <div>
    <!-- Data Table -->
    <v-data-table
      :headers="headers"
      :items="
        getPollensAll.map((x) => {
          return {
            ...x,
            nom_famille: getFamille.filter(
              (f) => f.id_famille === x.id_famille
            )[0].nom_famille,
            nom_genre: getGenre.filter((f) => f.id_genre === x.id_genre)[0]
              .nom_genre,
          };
        })
      "
      :search="search"
      :sort-by="['nom_famille', 'nom_genre']"
    >
      <!-- Customizing top bar of the data table -->
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Recherche espèce"
          ></v-text-field>
          <v-spacer></v-spacer>
          <!-- Open dialog on click on "Ajouter" button -->
          <v-btn color="#2B2118" dark class="mb-2" @click="openDialog">
            <v-icon left>mdi-plus-circle</v-icon> Ajouter Espèce
          </v-btn>

          <v-dialog v-if="dialog" v-model="dialog" width="1000px" scrollable>
            <v-card height="600px">
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4"
                      ><p class="text-h6">Taxonomie:</p></v-col
                    >
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-autocomplete
                        dense
                        outlined
                        :items="getFamille"
                        item-text="nom_famille"
                        item-value="id_famille"
                        label="Famille"
                        v-model="editedItem.id_famille"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-autocomplete
                        dense
                        outlined
                        :disabled="editedItem.id_famille === ''"
                        :items="
                          getGenre.filter(
                            (g) => g.id_famille === editedItem.id_famille
                          )
                        "
                        item-text="nom_genre"
                        item-value="id_genre"
                        label="Genre"
                        v-model="editedItem.id_genre"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                      dense
                        outlined
                        v-model="editedItem.espece"
                        label="Nom Espece"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        dense
                        outlined
                        v-model="editedItem.nom_revise"
                        label="Nom Espece (taxonomie revisée)"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4"
                      ><p class="text-h6">Général:</p></v-col
                    >
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        dense
                        outlined
                        v-model="editedItem.herbier"
                        label="Herbier"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        dense
                        outlined
                        v-model="editedItem.lame"
                        label="LAME"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        dense
                        outlined
                        v-model="editedItem.labo"
                        label="Laboratoire"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4"
                      ><p class="text-h6">Dimensions:</p></v-col
                    >
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        dense
                        outlined
                        v-model="editedItem.dimensionp"
                        label="Dimension P"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        dense
                        outlined
                        v-model="editedItem.dimensione"
                        label="Dimension E"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4"
                      ><p class="text-h6">Biblio et remarques:</p></v-col
                    >
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea
                        v-model="editedItem.biblio"
                        filled
                        label="Biblio"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea
                        filled
                        v-model="editedItem.remarques"
                        label="Remarques"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea
                        v-model="editedItem.pollenassocies"
                        filled
                        label="Pollen associes"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#2B2118" text @click="close"> Annuler </v-btn>
                <v-btn
                  :disabled="
                    editedItem.espece === '' ||
                    editedItem.id_genre === '' ||
                    editedItem.id_famille === ''
                  "
                  color="#2B2118"
                  dark
                  @click="save"
                >
                  Sauvegarder
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <DetailDialogEditEspece
            :dialog.sync="dialogEdit"
            :currentitem.sync="editedItem"
          ></DetailDialogEditEspece>

          <v-dialog v-model="dialogDelete" max-width="700px">
            <v-card>
              <v-card-title class="headline"
                >Voulez-vous vraiment supprimer cet élément?</v-card-title
              >
              <v-card-text>
                <p style="word-break: keep-all">
                  <span
                    >Espèce: {{ editedItem.nom_famille }}
                    >
                    {{ editedItem.nom_genre }}
                    >
                  </span>
                  {{ editedItem.espece }}
                </p>
                <p style="word-break: keep-all">
                  <span> L'opération n'est pas réversible. </span>
                </p>
                <p style="word-break: keep-all">
                  <span>
                    Pour compléter l'opération, il faut d'abord éliminer les
                    photos et les mots-clès associées à ce pollen.
                  </span>
                </p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#2B2118" dark @click="closeDelete">Annuler</v-btn>
                <v-btn color="#2B2118" text @click="deleteItemConfirm"
                  >Supprimer cet élément</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              @click="editItem(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Modifier informations</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              @click="managePhotos(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-image-multiple
            </v-icon>
          </template>
          <span> Gérer photos</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              @click="manageKeywords(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-tag-multiple
            </v-icon>
          </template>
          <span> Gérer mots clés</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon @click="deleteItem(item)" v-bind="attrs" v-on="on">
              mdi-delete
            </v-icon>
          </template>
          <span>Supprimer</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <a>No data available</a>
      </template>
    </v-data-table>

    <v-dialog
      @click:outside="setManagePhotoDetail(!getManagePhotoDetail)"
      v-model="getManagePhotoDetail"
      width="1200px"
      scrollable
    >
      <CrudEspeceManagePhotos
        v-if="getManagePhotoDetail"
      ></CrudEspeceManagePhotos>
    </v-dialog>

    <v-dialog
      @click:outside="setManageKeywordsDetail(!getManageKeywordsDetail)"
      v-model="getManageKeywordsDetail"
      width="1200px"
      scrollable
    >
      <CrudEspeceManageKeywords2
        v-if="getManageKeywordsDetail"
      ></CrudEspeceManageKeywords2>
      <!-- <CrudEspeceManageKeywords
        v-if="getManageKeywordsDetail"
      ></CrudEspeceManageKeywords> -->
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CrudEspeceManageKeywords2 from "./CrudEspeceManageKeywords2.vue";
import CrudEspeceManagePhotos from "./CrudEspeceManagePhotos.vue";
import DetailDialogEditEspece from "./DetailDialogEditEspece.vue";
export default {
  components: {
    CrudEspeceManagePhotos,
    CrudEspeceManageKeywords2,
    DetailDialogEditEspece,
  },
  data() {
    return {
      search: "",
      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      headers: [
        {
          text: "ID Pollen",
          align: "start",
          sortable: true,
          value: "id_pollen",
        },
        {
          text: "Famille",
          sortable: true,
          value: "nom_famille",
        },
        {
          text: "Genre",
          sortable: true,
          value: "nom_genre",
        },
        { text: "Nom Espece", value: "espece" },
        /*       {
        text: "Dimension P",
        sortable: false,
        value: "dimensionp",
      },
      {
        text: "Dimension E",
        sortable: false,
        value: "dimensione",
      }, */
        {
          text: "LAME",
          sortable: true,
          value: "lame",
        },
        {
          text: "Labo",
          sortable: true,
          value: "labo",
        },
        {
          text: "Herbier",
          sortable: true,
          value: "herbier",
        },

        {
          text: "Actions",
          value: "actions",
          align: "right",
          searchable: false,
          sortable: false,
        },
      ],
      editedIndex: -1,
      editedItem: {
        id_pollen: "",
        id_famille: "",
        id_genre: "",
        espece: "",
        lame: "",
        labo: "",
        herbier: "",
        dimensionp: "",
        dimensione: "",
        biblio: "",
        remarques: "",
        pollenassocies: "",
        nom_revise: "",
      },
      defaultItem: {
        id_pollen: "",
        id_famille: "",
        id_genre: "",
        espece: "",
        lame: "",
        labo: "",
        herbier: "",
        dimensionp: "",
        dimensione: "",
        biblio: "",
        remarques: "",
        pollenassocies: "",
        nom_revise: "",
      },
    };
  },

  computed: {
    ...mapGetters([
      "getPollensAll",
      "getFamille",
      "getGenre",
      "getManagePhotoDetail",
      "getManageKeywordsDetail",
      "getAdminActivePollenIndex",
    ]),
    formTitle() {
      return this.getAdminActivePollenIndex === -1
        ? "Ajouter Espèce"
        : "Modifier Espèce";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  methods: {
    ...mapActions(["addPollen", "updatePollen", "deletePollen"]),
    /* editItem(item) {
      this.setAdminActivePollenIndex(
        this.getPollensAll
          .map(function (e) {
            return e.id_pollen;
          })
          .indexOf(item.id_pollen)
      );

      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    }, */

    openDialog() {
      this.setAdminActivePollenIndex(-1);
      this.editedItem = Object.assign({}, this.defaultItem);
      this.dialog = true;
    },

    editItem(item) {
      this.setAdminActivePollenIndex(
        this.getPollensAll
          .map(function (e) {
            return e.id_pollen;
          })
          .indexOf(item.id_pollen)
      );

      this.editedItem = Object.assign({}, item);
      this.dialogEdit = true;
    },

    managePhotos(item) {
      this.setAdminActivePollenIndex(
        this.getPollensAll
          .map(function (e) {
            return e.id_pollen;
          })
          .indexOf(item.id_pollen)
      );
      this.$store.commit("setManagePhotoDialog", !this.getManagePhotoDetail);
    },

    manageKeywords(item) {
      this.setAdminActivePollenIndex(
        this.getPollensAll
          .map(function (e) {
            return e.id_pollen;
          })
          .indexOf(item.id_pollen)
      );
      this.$store.commit(
        "setManageKeywordsDialog",
        !this.getManageKeywordsDetail
      );
    },

    deleteItem(item) {
      this.setAdminActivePollenIndex(this.getPollensAll.indexOf(item));
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.deletePollen(this.editedItem.id_pollen);
      this.closeDelete();
    },

    close() {
      this.dialog = false;

      this.editedItem = Object.assign({}, this.defaultItem);
      this.setAdminActivePollenIndex(-1);
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.setAdminActivePollenIndex(-1);
      });
    },

    save() {
      this.addPollen(this.editedItem);

      this.close();
    },
    setManagePhotoDetail(isOpen) {
      this.$store.commit("setManagePhotoDialog", isOpen);
    },
    setAdminActivePollenIndex(index) {
      this.$store.commit("setAdminActivePollenIndex", index);
    },
  },
};
</script>

<style>
</style>